import type { FC } from "react";

import type { ICurrencyEnum, Tax } from "@jti/magento";
import { FormattedPrice, I18n } from "@jti/ui";

type PriceBlockTaxProps = {
  tax: Tax[];
  currencyCode: string;
  className?: string;
};

function isCurrencyObject(currency: unknown): currency is { code: ICurrencyEnum } {
  return typeof currency === "object" && currency !== null;
}

export const PriceBlockTax: FC<PriceBlockTaxProps> = ({ tax, currencyCode, className }) => {
  if (!tax || !Array.isArray(tax)) {
    return null;
  }

  return (
    <>
      {tax.map(({ label, amount: { currency, value } }) => {
        const displayedCurrencyCode = (isCurrencyObject(currency) ? currency.code : currency) || currencyCode;

        return (
          <div className={className} key={label}>
            <I18n t="cart.prices.incl_taxes">
              <FormattedPrice value={value} currency={displayedCurrencyCode} />
            </I18n>
          </div>
        );
      })}
    </>
  );
};
